import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import LoadingBar from '../../Modules/LoadingBar';
import UpdateFromPacer from '../../common/UpdateFromPacer';
import FilterTable from '../../common/FilterTable';
import HistorysFilters from './HistoryFilters';
import Flash from '../docket/Flash';

import './History.less';
import HistoryPaginator from './HistoryPaginator';
import HistoryEntries from './HistoryEntries';
import HistoryParserFilter from './HistoryParserFilter';
import Notification from '../../common/Notification/Notification';

class History extends Component {
  static propTypes = {
    onSubmit: PropTypes.func,
  };
  static defaultProps = {
    onSubmit: () => null,
  };

  render() {
    const { HistoryPopup } = this.props;
    if (!_.has(this.props.history, 'entries')) {
      return (
        <div className="history">
          <div id="history-tabs">
            <LoadingBar />
          </div>
        </div>
      );
    }

    return (
      <div className="history">
        <Notification />
        <Flash show={this.props.docketParts.showFlash} mailto={this.props.docketParts.email_address} />
        <div className={this.props.type}>
          <HistoryParserFilter
            {...this.props.docketFilterProps}
            keyword={this.props.docketFilterProps.keyword} />
          <HistoryPaginator {...this.props.historyPaginatorProps} togglePacerFilterSection={this.props.togglePacerFilterSection} showUpdateHistory={true}
          showPacerFilterSection={this.props.showPacerFilterSection} />
          {this.props.showPacerFilterSection && <HistorysFilters
            onSubmit={this.props.onSubmit}
            togglePacerFilterSection={this.props.togglePacerFilterSection}
            showPacerFilterSection={this.props.showPacerFilterSection}
            />
          }
          <HistoryEntries {...this.props.historyEntriesProps} tableSortProps={this.props.tableSortProps} />
          <HistoryPaginator {...this.props.historyPaginatorProps} showUpdateHistory={false} />
          {HistoryPopup && <HistoryPopup onClose={this.props.onPopupClick} info={this.props.popup} />}
          <UpdateFromPacer
            pacerUpdateHandler={this.props.purchaseData}
            pacerReceipt={this.props.receipt}
            lastUpdated={this.props.lastUpdated} />
        </div>
      </div>
    );
  }
}

History.defaultProps = {
  error: null,
  receipt: null,
  type: 'history',
};

History.propTypes = {
  case_uuid: PropTypes.string.isRequired,
  dataReady: PropTypes.bool.isRequired,
  history: PropTypes.any.isRequired,
  receipt: PropTypes.any,
  lastUpdated: PropTypes.any.isRequired,
  type: PropTypes.string,
  noDataFoundMessage: PropTypes.string.isRequired,
  getDocketDetails: PropTypes.any.isRequired,
  showRedactPopup: PropTypes.any.isRequired,
  buyPdf: PropTypes.any.isRequired,
  sortDockets: PropTypes.any.isRequired,
  updateClick: PropTypes.any.isRequired,
  pastEntriesClick: PropTypes.any.isRequired,
  historyEntriesProps: PropTypes.any.isRequired,
  onPopupClick: PropTypes.func.isRequired,
  error: PropTypes.any,
  purchaseData: PropTypes.func.isRequired,
  buyFromPacer: PropTypes.func.isRequired,
  buyFromAlfresco: PropTypes.func.isRequired,
  toggleEmailPopup: PropTypes.func.isRequired,
};

export default History;



// WEBPACK FOOTER //
// ./src/components/case/history/History.js